import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/Atharva-cloud/personalportfolio'
      className='link footer__link'
    >
      Created By Atharva Yeola
    </a>
  </footer>
)

export default Footer
